import React, { Component } from 'react';
import { get } from 'lodash';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { POLICY_FORM } from './forms/constants';
import onSubmitPolicy from './forms/onSubmitPolicy';
import validatePolicyForm from './forms/validatePolicyForm';
import CheckboxField from 'shared-components/reduxForms/fields/CheckboxField/CheckboxField';
import Button from '../elements-buttons/Button';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';

class HostPolicyMain extends Component {
  componentDidMount () {
    const SSOid = get(this.props.profile, 'SSOid');
    const { spaceId } = this.props.params;

    analyticsIntegrations.trackEvent('viewed host policies', {
      user_id: SSOid,
      space_id: spaceId
    });
  }

  render () {
    const {
      handleSubmit,
      params,
      error = '',
      submitFailed = false,
      intl,
      ...props
    } = this.props;

    const { spaceId } = params;
    const translationMessages = defineMessages({
      errorMessage: {
        id: 'hosting.host_policy_main.select_to_continue',
        defaultMessage: 'Please select to continue'
      }
    });

    return (
      <div className="HostPolicyMain">
        <div className="ps-container-lg-margin ps-container-fixed">
          <div className="ps-row margin-xl-bottom margin-xl-top">
            <div className="col-sm-9">
              <h2>
                <FormattedMessage
                  id="hosting.host_policy_main.policy_header"
                  defaultMessage="Please review the following Peerspace policies"
                />
              </h2>
              <p>
                <FormattedMessage
                  id="hosting.host_policy_main.policy_agreement"
                  defaultMessage="I agree and understand that as a Peerspace host I am required to:"
                />
              </p>
            </div>
          </div>
          <form onSubmit={handleSubmit(onSubmitPolicy)}>
            <div className="ps-row">
              <div className="col-md-8">
                <Field
                  className="margin-xl-bottom"
                  component={CheckboxField}
                  name="policy1"
                  id="policy1"
                  errorMessage={intl.formatMessage(translationMessages.errorMessage)}
                  label={
                    <div>
                      <div className="text-large heavy">
                        <FormattedMessage
                          id="hosting.host_policy_main.form_conversation_label"
                          defaultMessage="Keep conversations on Peerspace"
                        />
                      </div>
                      <div className="text-gray-600">
                        <FormattedMessage
                          id="hosting.host_policy_main.form_conversation_text"
                          defaultMessage="Keep conversations with guests on the platform so everyone knows
                        what was agreed to."
                        />
                      </div>
                    </div>
                  }
                />
                <Field
                  className="margin-xl-bottom"
                  component={CheckboxField}
                  name="policy2"
                  id="policy2"
                  errorMessage={intl.formatMessage(translationMessages.errorMessage)}
                  label={
                    <div>
                      <div className="text-large heavy">
                        <FormattedMessage
                          id="hosting.host_policy_main.form_payments_label"
                          defaultMessage="Use Peerspace to process payments"
                        />
                      </div>
                      <div className="text-gray-600">
                        <FormattedMessage
                          id="hosting.host_policy_main.form_payments_text"
                          defaultMessage="All payments must be processed on Peerspace and honor our service fee. All payouts will be made via direct deposit to your bank account."
                        />
                      </div>
                    </div>
                  }
                />
                <Field
                  className="margin-xl-bottom"
                  component={CheckboxField}
                  name="policy3"
                  id="policy3"
                  errorMessage={intl.formatMessage(translationMessages.errorMessage)}
                  label={
                    <div>
                      <div className="text-large heavy">
                        <FormattedMessage
                          id="hosting.host_policy_main.form_booking_label"
                          defaultMessage="Follow the booking, cancellation, and overtime policies"
                        />
                      </div>
                      <div className="text-gray-600">
                        <span>
                          <FormattedMessage
                            id="hosting.host_policy_main.form_booking_text"
                            defaultMessage="All bookings are covered by the"
                          />
                        </span>
                        &nbsp;
                        <a href="/legal/terms" target="_blank" rel="noopener noreferrer">
                          <FormattedMessage
                            id="hosting.host_policy_main.agreement_link_text"
                            defaultMessage="Peerspace Services Agreement"
                          />
                        </a>
                        <span>
                          <FormattedMessage
                            id="hosting.host_policy_main.form_contracts_text"
                            defaultMessage=". Contracts that conflict with these policies are not allowed."
                          /></span>
                      </div>
                    </div>
                  }
                />
                <Field
                  className="margin-xl-bottom"
                  component={CheckboxField}
                  name="policy4"
                  id="policy4"
                  errorMessage={intl.formatMessage(translationMessages.errorMessage)}
                  label={
                    <div>
                      <div className="text-large heavy">
                        <FormattedMessage
                          id="hosting.host_policy_main.form_space_label"
                          defaultMessage="Make sure my space meets local regulations"
                        /></div>
                      <div className="text-gray-600">
                        <FormattedMessage
                          id="hosting.host_policy_main.form_space_text"
                          defaultMessage="Follow local regulations to ensure the safety of your guests,
                        yourself, and your space."
                        />
                      </div>
                    </div>
                  }
                />
              </div>
              <div className="col-md-12">
                <div className="clearfix" />
                <hr />
                <div className="clearfix" />
                {
                  (error && submitFailed) && (
                    <p className="error text-danger text-small">
                      {error}
                    </p>
                  )
                }

                <div className="flex space-between margin-lg-top">
                  <a
                    href={`/your-space/${spaceId}/activate-listings`}
                    className="btn btn-default btn-outlined-light"
                  >
                    <FormattedMessage id="hosting.host_policy_main.back_link_text" defaultMessage="Back" />
                  </a>
                  <div>
                    <Button
                      attributes={{
                        "data-testing-id": 'policy-submit'
                      }}
                      category="primary"
                    >
                      <FormattedMessage
                        id="hosting.host_policy_main.form_button_text"
                        defaultMessage="Submit"
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

HostPolicyMain.propTypes = {
  handleSubmit: PropTypes.func,
  params: PropTypes.object,
  profile: PropTypes.object,
  error: PropTypes.string,
  submitFailed: PropTypes.bool,
  intl: intlShape
};

const config = {
  form: POLICY_FORM,
  validate: validatePolicyForm,
  enableReinitialize: true
};

export default reduxForm(config)(injectIntl(HostPolicyMain));
